import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes";
import "moment/locale/pt-br";
import moment from "moment";
import { ToastContainer } from "react-toastify";
import Provider from "./contexts";
import { initHeartbeat } from "./services/heartbeat";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

moment.locale("pt-br");

initHeartbeat();

function App() {
   return (
      <BrowserRouter>
         <LocalizationProvider dateAdapter={AdapterMoment}>
            {/* <ThemeProvider theme={theme}> */}
            <Provider>
               <Routes />
               <ToastContainer />
            </Provider>
            {/* </ThemeProvider> */}
         </LocalizationProvider>
      </BrowserRouter>
   );
}

export default App;
